import { render, staticRenderFns } from "./NexusStatesTable.vue?vue&type=template&id=017e2f8c"
import script from "./NexusStatesTable.vue?vue&type=script&lang=js"
export * from "./NexusStatesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports